import React from 'react';
import T from 'prop-types';
import {
    Col,
    ControlLabel,
    FormControl,
    FormGroup,
    HelpBlock,
    InputGroup,
    Row,
} from 'react-bootstrap';

export default function FieldGroup({
    id,
    errorMessage,
    label,
    value,
    horizontal = false,
    addon = null,
    readOnly = false,
    noBottomMargin = false,
    ...props
}) {
    if (horizontal) {
        return (
            <FormGroup
                controlId={id}
                validationState={errorMessage ? 'error' : null}
                style={{ marginBottom: noBottomMargin ? 0 : null }}
            >
                <Row style={{ marginBottom: noBottomMargin ? 0 : 10 }}>
                    <Col componentClass={ControlLabel} sm={4} style={{ marginTop: 10 }}>
                        {label}
                    </Col>
                    <Col sm={8} style={{ marginTop: 5 }}>
                        {!readOnly &&
                            !addon && <FormControl id={id} name={id} value={value} {...props} />}
                        {!readOnly &&
                            addon && (
                                <InputGroup>
                                    <FormControl id={id} name={id} value={value} {...props} />
                                    <InputGroup.Addon>{addon}</InputGroup.Addon>
                                </InputGroup>
                            )}
                        {readOnly && (
                            <p style={{ marginTop: 5 }}>
                                {value || '-'} {value ? addon : ''}
                            </p>
                        )}
                        {errorMessage && <HelpBlock>{errorMessage}</HelpBlock>}
                    </Col>
                </Row>
            </FormGroup>
        );
    }
    return (
        <FormGroup controlId={id} validationState={errorMessage ? 'error' : null}>
            <ControlLabel>{label}</ControlLabel>
            {!readOnly && !addon && <FormControl name={id} value={value} {...props} />}
            {!readOnly &&
                addon && (
                    <InputGroup>
                        <FormControl name={id} value={value} {...props} />
                        <InputGroup.Addon>{addon}</InputGroup.Addon>
                    </InputGroup>
                )}
            {readOnly && (
                <p style={{ marginTop: 5 }}>
                    {value || '-'} {value ? addon : ''}
                </p>
            )}
            {errorMessage && <HelpBlock>{errorMessage}</HelpBlock>}
        </FormGroup>
    );
}

FieldGroup.propTypes = {
    id: T.string,
    errorMessage: T.string,
    label: T.string.isRequired,
    value: T.string,
    horizontal: T.bool,
    addon: T.string,
    readOnly: T.bool,
    noBottomMargin: T.bool,
};
